module.exports = __webpack_public_path__ + "static/Solidu-1a7791cd3a2f911b8eab2efd256a9da4.png";